/**
 * useEventBuffer - How full the shared event ring buffer is
 *
 * Panel-level, so the Events tab carries a count before it is opened and the
 * 500-event cap is visible before it silently drops the start of a scenario.
 *
 * This is the service's own total, not the tab's: the tab shows a filtered and
 * possibly paused view, and the badge has to keep telling the truth while it
 * is paused.
 */

import { EventService } from 'Modules/softphone/services/EventService';
import { useEffect, useState } from 'react';

export interface EventBufferState {
  count: number;
  max: number;
}

export const useEventBuffer = (isActive: boolean): EventBufferState => {
  const [count, setCount] = useState(0);
  const eventService = EventService.getInstance();

  useEffect(() => {
    if (!isActive) {
      return;
    }

    setCount(eventService.getAll().length);

    // `onChange`, not `subscribe`: the badge has to follow the buffer being
    // emptied as well as filled, and a clear produces no event to subscribe to.
    return eventService.onChange(() => {
      setCount(eventService.getAll().length);
    });
  }, [eventService, isActive]);

  return { count, max: eventService.getMaxEvents() };
};
